import styled from 'styled-components';
import { CloseSmall } from '@hqo/react-components-library';

export const CloseIcon = styled(CloseSmall)`
  margin: 17px 17px 0 0;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.greys.adminBlack};
`;
